import { Component, OnInit, DestroyRef, inject, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.CUSTOMPACKAGE_READ,
    action: Permissions. CUSTOMPACKAGE_READ,
  },
  {
    key: PermissionKeys.CUSTOMPACKAGE_CREATE,
    action: Permissions.CUSTOMPACKAGE_CREATE,
  }
];

import moment from 'moment';
import { ColumnFilterComponent } from '../instances-mgmt/column-filter/column-filter.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-tenant-custom-image.component',
  templateUrl: './tenant-custom-image.component.html',
  styleUrl: './tenant-custom-image.component.scss',
  standalone: false
})
export class TenantCustomImageComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  constructor(public sidenavService: SidenavService, private activatedRoute: ActivatedRoute, private authService: AuthService, private router: Router, private permissionsService: PermissionsService,
    private solutionsService: SolutionsService, private toastrService: CustomToastrService,private cdRef: ChangeDetectorRef, public datePipe: DatePipe
  ) { }

  breadcrumbItems: BreadcrumbItem[] = [];
  tenantId: string; 
  solutions:any;
  allExternalPackages: any;
  showTable:boolean  = false;
  showSpinner:boolean = false;
  apiNotFound:boolean = false;
  customImageData: any;
  imageData: any;
  searchTerm: string;
  searchedResult = [];
  dropdownSearchValue: string;
  initialSolutions: any;
  selectedSolutionId:string;
  selectedSolutionValue:string;
  isSolutionsLoaded = false;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean; };
  status: any;
  dropdownsList: any;
  filteredColumns: any;
  clearData: boolean;
  filterStartDate: any;
  filterEndDate: any;
  selectedUser = [];
  date: any;
  createdBy: any;
  createdByUsers: any;
  isRestoringSelection = true;
  isUserTriggeredSelection = false;

  displayColumns = [
    {
      key: 'custImgName',
      name: translate('CUSTOM_IMAGES.CUST_IMG_NAME'),
      type: 'text',
      keyLink: 'navigation',
      sortable: true,
      visible: true,
      disable: true
    },
    {
    key: 'solutionName',
    name: translate('CUSTOM_IMAGES.SOLUTION_NAME'),
    type: 'text',
    sortable: false,
    visible: true,
    disable: true
    },
    {
      key: 'createdAt',
      name: translate('CUSTOM_IMAGES.CREATED_DATE'),
      type: 'date',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'createdBy',
      name: translate('CUSTOM_IMAGES.CREATED_BY'),
      type: 'userIcon',
      sortable: false,
      visible: true,
      disable: false
    },
    // {
    //   key: 'status',
    //   name: translate('CUSTOM_IMAGES.STATUS'),
    //   type: 'status',
    //   sortable: true,
    //   visible: true,
    //   disable: false
    // },

    {
      key: 'action',
      name: translate('RUNBOOK.ACTION'),
      type: 'action',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'CustomImageSettings',
      name: '',
      type: 'CustomImageSettings'
    }
  ];

  ngOnInit(): void {
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.CUSTOM_IMAGE';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['solutionId']) {
        this.selectedSolutionId = params['solutionId'];
        this.selectedSolutionValue = params['solutionName'];
        this.showSpinner = true;
        this.showTable = false;
      }
    });
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.breadcrumbItems.push({ label: 'Home', url: [RouterSegments.TENANT, this.tenantId] });
    this.breadcrumbItems.push({label: translate('CUSTOM_IMAGES.CUSTOM_IMAGE')});
    this.isSolutionsLoaded = false;
    this.solutionsService.getSolutions()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (data) {
      this.isSolutionsLoaded = true;
      this.solutions = Object.keys(data).map(key => ({id: data[key].id, value: data[key].name, selected: false}));
      this.solutions = this.solutions.sort((a,b) => (a.value.toLowerCase() < b.value.toLowerCase()) ? -1 : 1);
      this.initialSolutions = this.solutions;
      const selected = this.solutions?.find(s => s.id === this.selectedSolutionId);
      if (selected) {
        this.selectionChanged(selected.id);
        this.isRestoringSelection = false;
      } else {
        this.isRestoringSelection = false;
      }
      }
    }, (error) => {
      this.isSolutionsLoaded = true;
      setTimeout(() => {
        const title = translate('ERRORS.SERVICE_AVAILABILITY');
        const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
        this.toastrService.errMessage(message, title);
      }, 500);
    });
    if (localStorage.getItem('filteredCustomImageUser')) {
      const userData = JSON.parse(localStorage.getItem('filteredCustomImageUser'));
      if (userData) {
        this.selectedUser = userData;
        this.createdByUsers = this.selectedUser;
        this.dropdownsList?.[0]?.options?.forEach(element => {
          if(this.selectedUser.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    if (localStorage.getItem('filteredCustomDate')) {
      const dateData = JSON.parse(localStorage.getItem('filteredCustomDate'));
      if (dateData) {
        this.date = dateData;
        this.dropdownsList?.[1]?.options?.forEach(element => {
          if(dateData.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    this.filterStartDate = localStorage.getItem('filteredCustomImageStartDate') ? localStorage.getItem('filteredCustomImageStartDate'): '';
    this.filterEndDate = localStorage.getItem('filteredCustomImageEndDate') ? localStorage.getItem('filteredCustomImageEndDate'): '';
  }

  // redirecting to create custom image flow when create button is clicked
  createCustomImage(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CUSTOM_IMAGE,
      RouterSegments.CREATE]);
  }

  /**
 * Handles the change in selection and updates the necessary state.
 * @param {Object} event - The event object containing details of the selected solution.
 */
  selectionChanged(solutionId: string){
    if (!this.solutions || this.solutions.length === 0) {
      return;
    }
    const selected = this.solutions.find(s => s.id === solutionId);
    if (!selected) return;

    this.isRestoringSelection = !this.isUserTriggeredSelection;

    this.customImageData = [];
    this.searchTerm = '';

    this.selectedSolutionId = selected.id;
    this.selectedSolutionValue = selected.value;
      if (this.isUserTriggeredSelection) {
      this.resetImageData();
      this.clearPersistedFilters();
    }
    this.getCustomImages();
}

onUserSelectionChange(solutionId: string) {
  this.isUserTriggeredSelection = true;
  this.selectionChanged(solutionId);
}
  /**
 * Fetches custom image data related to the selected solution by calling the 
 * `getReferencePackages` API method. 
 * 
 * @returns {void}
 */
  getCustomImages(){
    this.allExternalPackages = [];
    this.showSpinner = true;
    this.apiNotFound = false;
    this.showTable = false;
    this.solutionsService.getReferencePackages(this.selectedSolutionId, this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data.total > 10) {
          const size = data.total
          this.solutionsService.getReferencePackages(this.selectedSolutionId, this.tenantId, size)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(results => {
              this.showSpinner = false;
              this.isRestoringSelection = false;
              this.allExternalPackages = results.data;
              if (this.allExternalPackages?.length) {
                this.showTable = true;
              }
              this.customImageData = this.allExternalPackages.map((obj) => ({ ...obj, solutionName: this.selectedSolutionValue, custImgName: obj.name, status: 'completed' }));
              this.customImageData = this.customImageData?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
              this.imageData = this.customImageData
              this.initializeFilterItems();
              this.applyPersistedFilters();
              this.isUserTriggeredSelection = false;
            });
        } else {
        this.showSpinner = false;
        this.isRestoringSelection = false;
        this.allExternalPackages = data.data;
        if (this.allExternalPackages?.length) {
          this.showTable = true;
        }
        this.customImageData = this.allExternalPackages.map((obj) => ({ ...obj, solutionName: this.selectedSolutionValue, custImgName: obj.name, status: 'completed' }));
        this.customImageData = this.customImageData?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        this.imageData = this.customImageData
        this.initializeFilterItems();
        this.applyPersistedFilters();
        this.isUserTriggeredSelection = false;
      }
      },
        (error) => {
          this.customImageData = [];
          setTimeout(() => {
            this.showSpinner = false;
            this.showTable = true;
            this.apiNotFound = true;
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        });
  }
  /**
 * Updates the `searchTerm` property with the provided search string.
 * This method is typically used to filter or search through a list of items based on 
 * the value passed as `searchTerm`. 
 * @param {string} [searchTerm] - The search term used to filter or search through data. 
 * If not provided, the current value of `searchTerm` is used.
 */
  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }
  /**
 * Updates the `searchedResult` property with the provided search results.
 * This method is used to store the results of a search operation.
 * @param {any} result - The result of the search operation, typically an array or object containing matching items.
 */
  searchedItems(result): void {
    this.searchedResult = result;
    this.cdRef.detectChanges();
  }
 /* Filters the table data based on the currently selected filter criteria */
  filterColumns(): void {
    if(this.createdBy) {
      this.dropdownsList[0].options.filter((item) => {
        if (this.createdBy?.find(createdBy => createdBy === item.value)) {
          item.selected = true;
        }
      });
    }
     if(this.date) {
      this.dropdownsList[1].options.filter((item) => {
        if (this.date?.find(date => date === item.value)) {
          item.selected = true;
        }
      });
    }
    const data = {
      name: translate('CUSTOM_IMAGES.CUSTOM_IMAGE'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      customCreatedBy: this.dropdownsList[0].options,
      createdDate: this.dropdownsList[1].options,
      customImageStartDateChange: this.dropdownsList[1].options[0]?.selected ? moment(this.filterStartDate) : '',
      customImageEndDateChange: this.dropdownsList[1].options[0]?.selected ? moment(this.filterEndDate) : '',
      customImageColumns: [
        'createdby',
        'date'
      ]
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(filteredColumns => {
      this.filteredColumns = filteredColumns;
      if (filteredColumns) {
        this.clearData = true;
        if(filteredColumns[0] !== '') {
          this.createdBy = filteredColumns[0];
        }
        if(filteredColumns[1] !== '') {
          localStorage.removeItem('filteredCustomDate');
          this.date = filteredColumns[1];
          localStorage.setItem('filteredCustomDate', JSON.stringify(filteredColumns[1]));
        }
         if (filteredColumns[0]?.length === 0 && filteredColumns[1]?.length === 0){
          this.resetCustomImageFilter();
        } else {
          this.filterCustomImageItems(filteredColumns);
        }
      }
    });
  }

  /* Filters the Custom Image table data based on the selected filter criteria. */
  filterCustomImageItems(filteredColumns): void {
    if (filteredColumns) {
      this.imageData = this.customImageData;
      this.selectedUser = filteredColumns[0] || [];
      if (filteredColumns[0]?.length > 0) {
        this.selectedUser = filteredColumns[0];
        if (filteredColumns[0].length > 0) {
          localStorage.setItem('filteredCustomImageUser', JSON.stringify(this.selectedUser));
          this.imageData = this.imageData?.filter(item => this.selectedUser?.includes(item?.createdBy));
        } else {
          localStorage.removeItem('filteredCustomImageUser');
        }
      }
      if (this.dropdownsList[1].options[0].selected && moment(filteredColumns[1][1].filteredStartDate).isValid() && moment(filteredColumns[1][1].filteredEndDate).isValid()) {
        this.filterStartDate = filteredColumns[1][1].filteredStartDate;
        this.filterEndDate = filteredColumns[1][1].filteredEndDate;
        localStorage.setItem('filteredCustomImageStartDate', this.filterStartDate);
        localStorage.setItem('filteredCustomImageEndDate', this.filterEndDate);
        
        const startDateUTC = moment.utc(moment(this.filterStartDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day');
        const endDateUTC = moment.utc(moment(this.filterEndDate).format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day');
        this.imageData = this.imageData?.filter(item => {
          const itemDateUTC = moment.utc(item.createdAt).startOf('day');
          return itemDateUTC.isSameOrAfter(startDateUTC) && itemDateUTC.isSameOrBefore(endDateUTC);
        });

      } else {
        this.filterStartDate = undefined;
        this.filterEndDate = undefined;
        localStorage.removeItem('filteredCustomImageStartDate');
        localStorage.removeItem('filteredCustomImageEndDate');
      }
    }
  }

  //preserve the filter data when coming back from custom image details page
  applyPersistedFilters(): void {

  const userData = localStorage.getItem('filteredCustomImageUser');
  const dateData = localStorage.getItem('filteredCustomDate');

  this.selectedUser = userData ? JSON.parse(userData) : [];
  this.date = dateData ? JSON.parse(dateData) : [];

  this.filterStartDate = localStorage.getItem('filteredCustomImageStartDate') || '';
  this.filterEndDate = localStorage.getItem('filteredCustomImageEndDate') || '';

  if (this.selectedUser?.length) {
    this.dropdownsList[0].options.forEach(opt => {
      opt.selected = this.selectedUser.includes(opt.value);
    });
  }

  const hasDate = this.filterStartDate && this.filterEndDate;

  if (this.dropdownsList?.[1]?.options?.length) {
    this.dropdownsList[1].options[0].selected = !!hasDate;
  }

  if (hasDate) {
    this.date = [
      'Created Date',
      {
        filteredStartDate: this.filterStartDate,
        filteredEndDate: this.filterEndDate
      }
    ];
  }

  this.filteredColumns = [
    this.selectedUser || [],
    this.date || []
  ];

  if (this.selectedUser?.length || hasDate) {
    this.filterCustomImageItems(this.filteredColumns);
  }
}

//reset the data
  resetImageData(): void {
    this.selectedUser = [];
    this.dropdownsList?.forEach(drop =>
      drop.options.forEach(opt => opt.selected = false)
    );
    this.imageData = this.customImageData;
  }

  //clear the perserved filter
  clearPersistedFilters(): void {
    localStorage.removeItem('filteredCustomImageUser');
    localStorage.removeItem('filteredCustomDate');
    localStorage.removeItem('filteredCustomImageStartDate');
    localStorage.removeItem('filteredCustomImageEndDate');
  }

  /* Converts the given date into a UTC timestamp. */
  getUTCTimestamp(date): any {
    return Date.parse(moment(new Date(date)).utc().format('DD MMM YYYY HH:mm:ss'));
  }

  /* Returns a label for the User */
   getUserLabel(user): void {
    const found = this.createdByUsers?.find(item => item.value === user);
    return found ? found.label : user || '-';
  }

  /* Cleares the selected User filter */
  cancelUserFilter(data) {
  const index = this.selectedUser.indexOf(data);

  if (index > -1) {
    this.selectedUser.splice(index, 1);
    const option = this.dropdownsList[0].options.find(item => item.value === data);
    if (option) option.selected = false;

    if (this.selectedUser.length > 0) {
      localStorage.setItem('filteredCustomImageUser', JSON.stringify(this.selectedUser));
    } else {
      localStorage.removeItem('filteredCustomImageUser');
    }

    const updatedFilters = [
      this.selectedUser,
      this.date || []
    ];

    this.filteredColumns = updatedFilters;

    this.filterCustomImageItems(updatedFilters);
  }
}

  /* Cleares the selected Date filter */
  cancelCustomImageDateFilter() {

  this.filterStartDate = undefined;
  this.filterEndDate = undefined;

  if (this.dropdownsList?.[1]?.options?.length) {
    this.dropdownsList[1].options[0].selected = false;
  }

  this.date = [];

  localStorage.removeItem('filteredCustomImageStartDate');
  localStorage.removeItem('filteredCustomImageEndDate');
  localStorage.removeItem('filteredCustomDate');

  const updatedFilters = [
    this.selectedUser || [],
    []
  ];

  this.filteredColumns = updatedFilters;

  this.filterCustomImageItems(updatedFilters);
}

  /* Reset the selected image filter */
  resetCustomImageFilter(): void {
    this.selectedUser = [];
    this.sidenavService.searchFilter.next('data');
    this.dropdownsList?.[0]?.options?.filter((item) => {item.selected = false});
    this.dropdownsList?.[1]?.options?.filter((item) => {item.selected = false});
    this.status = undefined;
    this.createdBy = undefined;
    this.date = undefined;
    this.filterStartDate = undefined;
    this.filterEndDate = undefined;
    this.imageData = this.customImageData;
    localStorage.removeItem('filteredCustomImageUser');
    localStorage.removeItem('filteredCustomDate');
    localStorage.removeItem('filteredCustomImageStartDate');
    localStorage.removeItem('filteredCustomImageEndDate');
  }
  /**
 * Resets the dropdown search value and restores the original list of solutions.
 * This method is used to reset the state of the dropdown to its initial configuration.
 * @returns {void}
 */
  resetDropdown() {
    setTimeout(() => {
    this.dropdownSearchValue = '';
    this.solutions = [...this.initialSolutions];
    }, 100);
  }
  /**
 * Updates the `solutions` list with the provided search string.
 * This method is typically used to filter or search through a list of items based on 
 * the value passed to search a solution. 
 * */
  searchChanged(value): void {
    this.solutions = this.initialSolutions?.filter(item => item?.value?.toLowerCase().startsWith(value.toLowerCase()));
  }

  //Initializes filter dropdowns
  initializeFilterItems(){
    this.createdByUsers = Array.from(
      new Set(this.imageData.map((item) => item.createdBy || '-'))).filter((user) => user && user !== '-').map((user) => ({
        value: user,
        label: user,
        selected: false,
      }));

    const date = [
      { value: 'Created Date', selected: false }
    ];
    this.dropdownsList = [
      {
        title: 'Created By',
        placeholder: 'Select User',
        options: this.createdByUsers
      },
      {
        title: 'Date',
        placeholder: 'Select Date',
        options: date
      }
    ];
  }
}
